<template>
  <div
    class="product__zenit-background"
    v-if="!loading"
    :class="{ 'product__zenit-background--loading': loading }">
      <!-- image -->
      <div 
        :style="!getViewPort ? `background-image: url(${backgroundZenit})` : ''"
        class="product__zenit-background__header"
        itemscope itemtype="http://schema.org/Product">
        <div class="product__zenit-background__header__image">
          <!--
          <img
            :alt="currentProduct.fields.title"
            :src="currentProduct.fields.mainPicture.fields.file.url"
          />
          -->
          <picture> 
            <source
              v-for="(image, index) of srcSetImages"
              :key="index"
              :media="`(max-width: ${index}px)`"
              :srcset="image">
            <img
              :src="srcSetImages[1024]"
              :alt="currentProduct.fields.title"
              itemprop="image">
          </picture>
          <!-- icons -->
          <div
            v-if="typeof iconsTags !== 'undefined'"
            class="product__zenit-background__content__icons">
            <ul>
              <li
                v-for="(iconTag, index) of iconsTags"
                :key="index">
                  <img
                    :src="iconTag.fields.tagIcon.fields.file.url"
                    :alt="iconTag.fields.title"
                    :width="iconTag.fields.tagIcon.fields.file.details.image.width / 2"
                    :height="iconTag.fields.tagIcon.fields.file.details.image.height / 2">
                  <strong>{{ iconTag.fields.title }}</strong>
              </li>
            </ul>
          </div>
        </div>
        <div class="product__zenit-background__header__body">
          <p
            v-if="productHasTagNews"
            class="product__zenit-background__productHasTagNews">
              Prodotto novità
          </p>
          <h1 itemprop="name">{{ currentProduct.fields.title }}</h1>
          <h2>BRAND:
            <router-link
              v-for="(brand, index) of brandTags"
              :key="index"
              :class="'underline_link'" 
              :to="{ name: 'single-tag', params: { slug: brand.fields.slug } }"
              itemprop="brand">
              {{ brand.fields.title }}
            </router-link>
          </h2>
          <div 
            v-html="description"
            itemprop="description"/>
        </div>
        
      </div>
      <!-- features -->
      <div
        v-if="!loading"
        class="product__zenit-background__content">
        <div class="product__zenit-background__content__features">
          <div 
            v-if="currentProduct.fields.features"
            class="product__zenit-background__content__features__column product__zenit-background__content__features__column--download">
            <ul>
              <li><h2>Download</h2></li>
              <li
                v-for="(pdf, index) of currentProduct.fields.features"
                :key="index">
                <a :href="pdf.fields.file.url">
                  <img :src="downloadIcon" :alt="pdf.fields.description"> {{ pdf.fields.description }}
                </a>
              </li>
            </ul>
          </div>
          <div class="product__zenit-background__content__features__column" v-html="features2"></div>
          <div class="product__zenit-background__content__features__column" v-html="features3"></div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import matchMedia from '@/mixins/matchMedia.js'
import { INLINES } from '@contentful/rich-text-types';

const options = {
  renderNode: {
    [INLINES.ENTRY_HYPERLINK]: (node, next) => {
      const contentTypeId = node.data.target.sys.contentType.sys.id
      const map = {
        'products': 'prodotto',
        'category': 'categoria',
        'posts': 'cosa-usare-per',
        'tags': 'tag'
      }
      if (typeof map[contentTypeId] !== 'undefined'){
        return `<a class="underline_link" target="_blank" href="/${map[contentTypeId]}/${node.data.target.fields.slug}/">${node.content[0].value}</a>`
      }
      else return '<strong>Problem during link render</strong>'
    },
    [INLINES.HYPERLINK]: (node, next) => {
      return `<a class="underline_link" target="_blank" href="${node.data.uri}">${node.content[0].value}</a>`
    }
  }
}

export default {
  mixins: [matchMedia],
  data: () => ({
    loading: true,
    backgroundZenit: require('@/assets/home/background-zenit-pitture.png'),
    downloadIcon: require('@/assets/icons/download.svg')
  }),
  props: {
    slug: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'product'
    ]),
    currentProduct: {
      get () {
        return this.product(this.slug)
      }
    },
    description: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.description, options).replace(/\n/g, `</br>`) : ''
      }
    },
    features2: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.features2).replace(/\n/g, `</br>`) : ''
      }
    },
    features3: {
      get () {
        return !this.loading ? documentToHtmlString(this.currentProduct.fields.features3).replace(/\n/g, `</br>`) : ''
      }
    },
    productHasTagNews: {
      get () {
        if (this.loading) return false
        if (typeof this.currentProduct.fields.tags === 'undefined') return false
        return this.currentProduct.fields.tags.some(tag => tag.sys.id === '1EiZKOpvDNKhXd2z0xHWJd')
      }
    },
    brandTags: {
      get () {
        if (this.loading) return []
        if (typeof this.currentProduct.fields.tags === 'undefined') return []
        return this.currentProduct.fields.tags.filter(currentTag => typeof currentTag.fields.parentGroup !== 'undefined' && currentTag.fields.parentGroup.sys.id === '2g44QxAIFXth5Ngz8iHb3X')
      }
    },
    iconsTags: {
      get () {
        if (this.loading) return undefined
        if (typeof this.currentProduct.fields.tags === 'undefined') return undefined
        const iconsTagsArray = this.currentProduct.fields.tags.filter(tag => typeof tag.fields.tagIcon !== 'undefined')
        if (iconsTagsArray.length === 0) return undefined
        return iconsTagsArray.sort((a, b) => a - b)
      }
    },
    srcSetImages: {
      get () {
        if (this.loading) return undefined
        return {
          '640': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=210&fit=scale`,
          '1024': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=400&fit=scale`,
          '1440': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=580&fit=scale`,
          '1920': `${this.currentProduct.fields.mainPicture.fields.file.url}?w=760&fit=scale`,
        }
      }
    },
    getViewPort: {
      get () {
        return this.matchMedia === 'medium' || this.matchMedia === 'small'
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadProducts'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadProducts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./text.scss";
  @import "./background.scss";
</style>
